import React from 'react';
import type { Color, PieceType } from '@jester-chess/shared';
import { PieceIcon } from './PieceIcon';
import './PawnPromotion.css';

interface PawnPromotionProps {
  color: Color;
  onSelect: (pieceType: PieceType) => void;
}

export const PawnPromotion: React.FC<PawnPromotionProps> = ({ color, onSelect }) => {
  const promotionOptions: PieceType[] = ['queen', 'rook', 'bishop', 'knight'];

  return (
    <div className="pawn-promotion-overlay">
      <div className="pawn-promotion-modal">
        <h3>Promote Pawn</h3>
        <p>Choose a piece to promote your pawn to:</p>
        <div className="promotion-options">
          {promotionOptions.map((pieceType) => (
            <button
              key={pieceType}
              className="promotion-option"
              onClick={() => onSelect(pieceType)}
              aria-label={`Promote to ${pieceType}`}
            >
              <PieceIcon piece={{ type: pieceType, color, square: { file: 'a', rank: 1 } }} />
              <span className="promotion-label">{pieceType}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

